module.exports = __webpack_public_path__ + "static/media/breakpoint.e0597364.png";